import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icon/app-store.svg")